var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 0.666664C4.39935 0.666664 0.666016 4.4 0.666016 9C0.666016 13.6 4.39935 17.3333 8.99935 17.3333C13.5993 17.3333 17.3327 13.6 17.3327 9C17.3327 4.4 13.5993 0.666664 8.99935 0.666664ZM9.83268 13.1667H8.16602V11.5H9.83268V13.1667ZM9.83268 9.83333H8.16602V4.83333H9.83268V9.83333Z",
    fill: "#CB282E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRedFilled);
export default __webpack_public_path__ + "static/media/error-red-filled.645d0ac8b58dca917d58aaeb8afd2eb0.svg";
export { ForwardRef as ReactComponent };